import React from 'react';
import { SortOrder } from 'antd/es/table/interface';

type OptionsProps = {
  description: string;
  renderNode?: React.ReactNode;
  value: string;
}

export const getFilters = (
  notificationList: any[],
  key: string,
  render?: (value: any) => string,
  validation?: (index: any) => boolean,
  renderNode?: (value: any) => React.ReactNode
) => {
  const types: any = {};
  const filterList: OptionsProps[] = [];
  notificationList?.forEach((file) => {
    if (file[key] === undefined || file[key] === null) {
      return;
    }
    const updateIndex = render ? render(file[key]) : file[key];

    if (
      types[updateIndex] === undefined &&
      (!validation || (validation && validation(updateIndex)))
    ) {
      types[updateIndex] = true;
      filterList.push({
        description: updateIndex.toString(),
        renderNode: renderNode && renderNode(updateIndex),
        value: updateIndex.toString()
      });
    }
  });

  return filterList;
}

export const textDate = [
  'Hoje',
  'Últimos 7 dias',
  'Últimos 15 dias',
  'Últimos 30 dias',
  'Últimos 90 dias',
]

export const filterDate = (
  notificationList: any[],
  key: string,
  render?: (value: any) => string[],
  validation?: (index: any) => boolean,
  renderNode?: (value: any) => React.ReactNode
) => {
  const types: any = {};
  const filterList: OptionsProps[] = [];
  notificationList?.forEach((file) => {
    if (file[key] === undefined || file[key] === null) {
      return;
    }
    const updateIndex = render ? render(file[key]) : file[key];

    if (
      types[updateIndex] === undefined &&
      (!validation || (validation && validation(updateIndex)))
    ) {
      types[updateIndex] = true;
      filterList.push({
        description: updateIndex.toString(),
        renderNode: renderNode && renderNode(updateIndex),
        value: updateIndex.toString()
      });
    }
  });

  return filterList;
}

type INotificationValidOrderKey = 'notifications' | 'obra' | 'users' | 'data';

const labelKeyMap: Record<INotificationValidOrderKey, string> = {
  notifications: 'notification:page.labelNotifications',
  obra: 'notification:page.labelObra',
  users: 'notification:page.labelUsers',
  data: 'notification:page.labelData',
}

export const getOrderTitle = (
  order: SortOrder,
  titleKey: INotificationValidOrderKey
) => {
  // imported locally to avoid circular import issues at module load
  const i18n = require('i18n').default;
  const title = i18n.t(labelKeyMap[titleKey]);

  if (order === null) {
    return i18n.t('notification:page.sortAsc', { title });
  }
  if (order === 'ascend') {
    return i18n.t('notification:page.sortDesc', { title });
  }
  return i18n.t('notification:page.sortDisable', { title });
}
